export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/jti/HomeView.vue'),
  },
]
